// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const HeartRateOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M23.54 8.52H18a.47.47 0 00-.43.3l-1.3 3.25-1.05-4.56a.46.46 0 00-.45-.36c-.22 0-.4.15-.45.37l-2.59 11.82-1.58-17.77a.46.46 0 00-.38-.41.46.46 0 00-.5.26L5.7 9.45H.46a.46.46 0 000 .92H6c.18 0 .35-.1.42-.27L9.4 3.43l1.69 19c.02.22.2.4.43.41h.03c.21 0 .4-.14.45-.36l2.8-12.76.91 4a.47.47 0 00.88.06l1.73-4.33h5.23a.46.46 0 000-.93zm0 0","fill":"currentColor"}}]},"name":"heart-rate","theme":"outlined"};

const HeartRateOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={HeartRateOutlinedSvg} />;
  HeartRateOutlined.displayName = 'HeartRateOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(HeartRateOutlined);
